import { apiLocal } from "./servers/apiInternal";

export async function fetchTotaisStatus(tribunal?: string) {
  const resp = await apiLocal.get("/integrations/solucionare/totais-status", {
    params: { tribunal },
  });
  return resp.data;
}

export async function fetchTotaisTribunalStatus(status?: string) {
  const resp = await apiLocal.get("/integrations/solucionare/totais-tribunal-status", {
    params: { status },
  });
  return resp.data;
}

export async function fetchLista({ tribunal, status, cnj, instancia, page = 1, pageSize = 30 }: {
  tribunal?: string;
  status?: string;
  cnj?: string;
  instancia?: string;
  page?: number;
  pageSize?: number;
}) {
  const resp = await apiLocal.get("/integrations/solucionare/list", {
    params: { tribunal, status, cnj, instancia, page, pageSize },
  });
  return resp.data;
}

